
import { Vue, Component } from 'vue-property-decorator';
import TMessage from './message.vue';
import TIcon from './icon';

@Component({
  components: {
    TMessage,
    TIcon,
  },
})
export default class MessageTemp extends Vue {
  private show: boolean = false;

  private className: string = '';

  private wrapperClassName: string = '';

  private type: string = 'info';

  private title: string = '欢迎使用TMessage !';

  private closable: boolean = false;

  private iconImg: string = '';

  private duration: number = 2800;

  private timer: any = null;

  private onClose?: Function;

  // 关闭之后的回调
  close() {
    this.show = false;
    if (this.onClose) this.onClose(this);
    this.$el.addEventListener('animationend', () => this.$destroy());
  }

  // 开始计数器
  startTimer() {
    if (this.duration > 0 && this.type !== 'loading') {
      this.timer = setTimeout(() => {
        if (this.show) this.close();
      }, this.duration);
    }
  }

  mounted() {
    if (this.type !== 'loading') this.startTimer();
  }

  // 删除dom元素
  destroyed() {
    if (this.timer) clearTimeout(this.timer);
    const pdom: any = this.$el.parentNode;
    pdom.removeChild(this.$el);
  }
}
